// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3N5MT","noInteraction":"EventWrapper_noInteraction__398aa"};